import React from 'react';

const IconSend = ({ color, width, height }) => {
  return (
    <svg fill={color} height={height} width={width} viewBox="0 0 24 24">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

export default IconSend;



// WEBPACK FOOTER //
// ./src/IconSend.js